export default __webpack_public_path__ + "static/media/tampering_img_2.0ea6030f.png";